const alertSuccess = {
  mixins: [alertDismissible],
  props: ["msgs", "dismissible"],
  template: `
      <div class="alert alert-success alert--icon fade"
        :class="[dismissibleClass, showAlertClass]"
        role="alert">
          <ul class="ulClear">
              <li v-for="(msg,index) in msgs"
                  :key="index">
                  <span v-html="msg"></span>
              </li>
          </ul>
          <button @click="close" v-if="dismissible" type="button" class="btn-close" aria-label="Close"></button>
      </div>`,
  
};

commonComponents.push({
  name: "alert-success",
  var: alertSuccess,
});
